import { render, staticRenderFns } from "./DlgHistory.vue?vue&type=template&id=0c002808&scoped=true"
import script from "./DlgHistory.vue?vue&type=script&lang=js"
export * from "./DlgHistory.vue?vue&type=script&lang=js"
import style0 from "./DlgHistory.vue?vue&type=style&index=0&id=0c002808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c002808",
  null
  
)

export default component.exports